import { PLATFORM_COLORS } from "../../lib/platformColors.mjs";

const ALL = "ALL";
const TOTAL = "TOTAL";

// initial state
const initialState = {
  newDeliverable: {},
  all: [],
  // How many deliverables the event ACTUALLY has, when the server inlined only
  // the first page and views/deliverables/index.vue is still streaming the
  // rest in. `null` means "what's in `all` is all there is" — every call site
  // that doesn't paginate leaves it null and `count` behaves as it always has.
  total: null,
  current: {},
  error: null,
  colors: PLATFORM_COLORS,
};

// getters
const storeGetters = {
  count(state) {
    // The deliverables tab badge reads this. While pages 2..N are still in
    // flight `all` is only what has arrived, and a badge that counts down from
    // "100" on an 11,775-deliverable event is worse than a slow page.
    return state.total === null || state.total === undefined
      ? state.all.length
      : state.total;
  },
  inferredTypeAsLabel: () => (type) => {
    switch (type) {
      case "url":
        return "Article";
      case "youtube":
        return "YouTube";
      case "constant_contact":
        return "Constant Contact";
      case "campaignmonitor":
        return "Campaign Monitor";
      case "short_io":
        return "Short.io";
      case "tik_tok":
        return "TikTok";
      case "omny_studio":
      default:
        return type;
    }
  },
  inferredTypeAsIconClass: () => (type) => {
    // A deliverable's type is legitimately unknown for a moment: the url
    // watcher in views/deliverables/form.vue clears inferred_type on every
    // keystroke (the old classification is stale) and waits for the server to
    // re-infer it from the new URL. Called with that empty value this getter
    // used to throw inside the card's render; Vue then aborts the patch, so
    // the whole card stops updating -- and if the save never lands, it stays
    // frozen (error banner included) until the page is reloaded.
    // Degrade the same way inferredTypeAsLabel does, which renders "Choose".
    if (!type) {
      return "";
    }

    let deliverableType = type;
    if (type.includes("Other")) {
      deliverableType = "other";
    }
    if (type.includes("_profile")) {
      deliverableType = type.replace("_profile", "");
    }

    switch (deliverableType) {
      case "url":
        return "linkify";
      case "youtube":
        return "you-tube";
      case "bitly":
        return "bitly";
      case "mailchimp":
      case "convertkit":
      case "beehiiv":
      case "drip":
      case "constant_contact":
      case "aweber":
      case "activecampaign":
      case "campaignmonitor":
      case "mailerlite":
      case "email":
        return "envelope";
      case "other":
        return "sticky note outline";
      case "instagram_stories":
        return "instagram";
      case "push_engage":
        return "bullhorn";
      case "art19":
        return "podcast";
      case "reddit":
        return "reddit";
      default:
        return deliverableType;
    }
  },
};

// actions
const actions = {
  setAll({ commit }, { items }) {
    commit(ALL, { items });
  },
  setTotal({ commit }, { value }) {
    commit(TOTAL, { value });
  },
};

// mutations
const mutations = {
  [ALL](state, { items }) {
    state.error = null;
    state.all = items;
  },
  [TOTAL](state, { value }) {
    state.total = value === null || value === undefined ? null : Number(value);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters: storeGetters,
  actions,
  mutations,
};
